import { render, staticRenderFns } from "./CompCopy.vue?vue&type=template&id=5135f710"
import script from "./CompCopy.vue?vue&type=script&lang=js"
export * from "./CompCopy.vue?vue&type=script&lang=js"
import style0 from "./CompCopy.vue?vue&type=style&index=0&id=5135f710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports